"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const ClubComponents_1 = require("components/ClubComponents");
const cosmos_1 = require("components/cosmos");
const toast_1 = __importDefault(require("components/cosmos/toast"));
const History_1 = require("configs/routes/History");
const mobx_react_1 = require("mobx-react");
const featureToggle_1 = require("modules/featureToggle");
const file_1 = require("modules/file");
const playerBackofficeModal_1 = __importDefault(require("modules/playerBackoffice/playerBackofficeModal"));
const ui_1 = require("modules/ui");
const club_files_ui_1 = require("@hotmart/club-files-ui");
require("@hotmart/cosmos/dist/form/form.css");
require("@hotmart/cosmos/dist/form/input-custom.css");
require("@hotmart/cosmos/dist/form/input-switch.css");
const Content = ({ basename, children, loading, isCreateModuleConceptEnabled }) => {
    const history = (0, react_1.useMemo)(() => (0, History_1.getHistory)(basename), [basename]);
    (0, react_1.useEffect)(() => {
        const unregisterHistoryChangeEventDispatcher = (0, History_1.registerHistoryChangeEventDispatcher)(history, isCreateModuleConceptEnabled);
        return () => {
            unregisterHistoryChangeEventDispatcher === null || unregisterHistoryChangeEventDispatcher === void 0 ? void 0 : unregisterHistoryChangeEventDispatcher();
        };
    }, [history, isCreateModuleConceptEnabled]);
    if (loading) {
        return (0, jsx_runtime_1.jsx)(cosmos_1.Loading, { center: true });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_router_1.Router, { history: history, children: children }), (0, jsx_runtime_1.jsx)(ClubComponents_1.DrawerManager, {}), (0, jsx_runtime_1.jsx)(toast_1.default, {}), (0, jsx_runtime_1.jsx)(club_files_ui_1.UploadLibrary, { onError: ui_1.UiService.handleInvalidToken, onLocalUpload: file_1.FileService.onLibraryLocalUpload, onLibraryUpload: file_1.FileService.onLibraryUpload, customProviderModal: playerBackofficeModal_1.default })] }));
};
const mapStateToProps = (stores) => ({
    isCreateModuleConceptEnabled: stores.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.CreateModuleConcept)
});
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(Content);
